import React, { useState } from 'react';
import { Tooltip, Row, Col } from 'antd';
import PaginationTable from '../../../../../shared/PaginationTable';

// Global Styling
import {
  TableColumnTitle,
  PrimaryTableRowText,
  TooltipText,
} from '../../../../../shared/globalStyling/styledText';
import { formatWholeNumber } from '../../../../../../core/utils/campaigns';
import uuid from 'uuid';

const LocationCityTable = ({ cityData }) => {
  const [currentPage, setCurrentPage] = useState(1);

  const topCites = cityData.slice(0, 25);

  const columns = [
    {
      title: '',
      dataIndex: 'color',
      key: 'color',
      width: '15px',
      render: (text) => {
        return (
          <Row
            type="flex"
            justify="center"
            align="middle"
            style={{
              width: '100%',
            }}
          >
            <div
              style={{
                backgroundColor: text,
                height: '15px',
                width: '15px',
                minWidth: '15px',
                borderRadius: '50px',
              }}
            />
          </Row>
        );
      },
    },
    {
      title: <TableColumnTitle text={'City'} />,
      dataIndex: 'value',
      key: 'value',
      width: '35%',
      align: 'left',
      render: (text) => {
        if (text) {
          return (
            <Row
              type="flex"
              justify="start"
              align="middle"
              style={{
                width: '100%',
              }}
            >
              <Col span={24}>
                {text.length > 45 ? (
                  <Tooltip title={<TooltipText text={text} />}>
                    <span>
                      <PrimaryTableRowText text={text.slice(0, 46).concat('...')} />
                    </span>
                  </Tooltip>
                ) : (
                  <PrimaryTableRowText text={text} />
                )}
              </Col>
            </Row>
          );
        } else {
          return <div />;
        }
      },
    },
    {
      title: <TableColumnTitle text={'State'} />,
      dataIndex: 'STATE',
      footerSum: true,
      key: 'state',
      width: '20%',
      align: 'left',
      render: (text) => <PrimaryTableRowText text={text ? text : 'N/A'} />,
    },

    {
      title: <TableColumnTitle text={'Audience Signals'} />,
      footerSum: true,
      dataIndex: 'MATCHES',
      key: 'MATCHES',
      width: '35%',
      align: 'left',
      render: (MATCHES) => <PrimaryTableRowText text={MATCHES && formatWholeNumber(MATCHES)} />,
    },
  ];

  return (
    <PaginationTable
      bordered={false}
      columns={columns}
      data={topCites}
      scroll={{ x: 300, y: 400 }}
      paginationSize={'default'}
      size={'default'}
      total={topCites.length}
      current={currentPage}
      pageSize={10}
      onChange={(paginationObject) => {
        setCurrentPage(paginationObject.current);
      }}
      rowKey={(record) => `${record.id}${uuid.v4()}`}
    />
  );
};

export default LocationCityTable;
